module.exports = __webpack_public_path__ + "img/yuanmingyuan big (9).0eeafd12.jpg";